import React from 'react';
import {
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import { Link } from 'react-router-dom';
import DateRangePickerComp from 'components/DatePicker/DateRangePicker';
import moment from 'moment';
import {
  MdSearch, MdCampaign
} from 'react-icons/md';
import { checkPermissions } from 'hooks';
import CampaignAnalytics from './campaignAnalytics';
import DashboardWidget from '../../components/DashboardWidget';

const DashboardComponent = (props) => {

  const [campaignSearched, setCampaignSearched] = React.useState(false);
  const [postSearched, setPostSearched] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState('POST');
  const [filter, setFilter] = React.useState(null);
  const [defaultRange] = React.useState(
    {
      startDate: moment().toDate(),
      endDate: moment().toDate(),
      key: 'selection'
    }
  );
  const [dateRange, setDateRange] = React.useState(defaultRange);
  const [widgetsList, setWidgetsList] = React.useState([]);
  
  
  const handleDateChange = (date) => {
    setDateRange(date);
  }

  React.useEffect(() => {
    (!campaignSearched || !postSearched) && handleSearch();
  }, [props.loginData, activeTab])


  const handleSearch = () => {
    const startDateString = dateRange.startDate ? moment(dateRange.startDate).format('YYYY-MM-DD') : '';
    const endDateString = dateRange.endDate ? moment(dateRange.endDate).format('YYYY-MM-DD') : '';
    const payload = { start_date: startDateString, end_date: endDateString };
    setFilter(payload);
    if (activeTab === 'POST') {
      setPostSearched(true);
    }
    if (activeTab === 'CAMPAIGN') {
      setCampaignSearched(true);
      props.getCampaignAnalytics(payload);
      props.getTransactionsGraphData(payload);
      props.getActiveCampaignMapData(payload);
    }
  }

  const handleTab = (tab) => {
    setActiveTab(tab)
  }

  React.useEffect(() => {
    setWidgetsList(props.widgetSaved);
  }, [props.widgetSaved])

  return (
    <div>
      
      <DateRangePickerComp handleDateChange={handleDateChange} handleSearch={handleSearch} defaultRange={defaultRange} />
      <Link style={{float:'right',marginTop:'-60px'}} to="/dashboard-widgets">Manage Widgets</Link>
      <Nav tabs>
        {(checkPermissions(props.loginData, 'dashboard_data') || checkPermissions(props.loginData, 'google_analytics')
          || checkPermissions(props.loginData, 'google_analytics_graph') || checkPermissions(props.loginData, 'top_searches')) &&
          <NavItem>
            <NavLink
              className={(activeTab === 'POST') ? 'active' : ''}
              onClick={() => handleTab('POST')} >
              <MdSearch style={{ color: '#3aacd6', marginRight: 10, fontSize: 25 }} /> Users and Searches
            </NavLink>
          </NavItem>
        }
        {(checkPermissions(props.loginData, 'campaign_analytics') && (process.env.REACT_APP_VERSION && process.env.REACT_APP_VERSION !== '1.0.0')) &&
          <NavItem>
            <NavLink
              className={(activeTab === 'CAMPAIGN') ? 'active' : ''}
              onClick={() => handleTab('CAMPAIGN')} >
              <MdCampaign style={{ color: '#3aacd6', marginRight: 10, fontSize: 25 }} /> Campaigns
            </NavLink>
          </NavItem>
        }
      </Nav>

      <TabContent activeTab={activeTab} style={{ paddingTop: 30 }}>

        <TabPane tabId="POST">
          {
            widgetsList.map((item) => {
              return (<DashboardWidget id={item.id} filter={filter} />)
            })
          }
        </TabPane>

        <TabPane tabId="CAMPAIGN">
          <CampaignAnalytics {...props} />
        </TabPane>
      </TabContent>

    </div>
  );
}

export default DashboardComponent;

